import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/organizations/ssoUpdate';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error as ErrorAction } from '../../actions/error/error';

const unwrap = (res) => (res && res.data && res.data.data !== undefined ? res.data.data : (res && res.data) || {});

function* operation(action) {
  const { orgId, body } = action.payload;
  try {
    const res = yield call(
      axios.put,
      `${config.API_URL}/organization/${orgId}/sso`,
      body,
      { headers: getLocalUser() },
    );
    yield put({ type: 'SHOW_SUCCESS_SNACKBAR', message: 'SSO configuration saved' });
    yield put(fetchSuccess(unwrap(res)));
  } catch (err) {
    yield put(ErrorAction(err));
    const message = err?.response?.data?.message
      || err?.response?.data?.data?.message
      || 'Could not save SSO configuration';
    yield put({ type: 'SHOW_ERROR_SNACKBAR', message });
    yield put(fetchFailure(message));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
